import { useEffect, useState } from 'react'

/**
 * Delay value until idle or a timeout occurs. Will cancel previous invoke if called again.
 * When value is undefined, there will be no delay for the first value.
 */
export const useDelayedValue = <T>(value: T, delayMS: number) => {
  const [delayedValue, setDelayedValue] = useState<T>()

  useEffect(() => {
    const handle = setTimeout(() => setDelayedValue(value), delayMS)
    /** A new value cancels the pending one, and so does unmount: no timer outlives the component */
    return () => clearTimeout(handle)
  }, [delayMS, value])

  return delayMS > 0 ? delayedValue : value
}
